// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__fIklU","tab":"Tabs_tab__28s7C","tabActive":"Tabs_tabActive__JaKWr"};